import { render, staticRenderFns } from "./full_screen_post.vue?vue&type=template&id=452c3fce&scoped=true&"
import script from "./full_screen_post.vue?vue&type=script&lang=js&"
export * from "./full_screen_post.vue?vue&type=script&lang=js&"
import style0 from "./full_screen_post.vue?vue&type=style&index=0&id=452c3fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c3fce",
  null
  
)

export default component.exports